import { render } from "./CircleVectorSvg.vue?vue&type=template&id=2c13c41e"
import script from "./CircleVectorSvg.vue?vue&type=script&lang=js"
export * from "./CircleVectorSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__